import { addMinutes, format, startOfDay } from 'date-fns';

export const minuteOffsetToTime = (offsetMinutes: number, startDate?: string) => {
  const midnight = startOfDay(startDate ? new Date(startDate) : new Date());
  const time = addMinutes(midnight, offsetMinutes);
  return format(time, 'HH:mm');
};

/** Whole minutes as a duration label (e.g. "2h 15m"), not a clock time. */
export const formatDurationMinutesHuman = (totalMinutes: number): string => {
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) return '0m';
  const rounded = Math.round(totalMinutes);
  const h = Math.floor(rounded / 60);
  const m = rounded % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

/** Slot list rows: always `Hh MMm` (minutes two digits), e.g. `0h 01m`, `2h 05m`. */
export function formatDurationHoursMinutesSlot(totalMinutes: number): string {
  if (!Number.isFinite(totalMinutes)) return '0h 00m';
  const rounded = Math.max(0, Math.round(totalMinutes));
  const h = Math.floor(rounded / 60);
  const m = rounded % 60;
  return `${h}h ${String(m).padStart(2, '0')}m`;
}
